<template>
  <div style="margin-bottom: 16px;">
    <div class="defaultTableHeader">
      {{catalogueType}} {{catalogueType=='A'?'货物类':(catalogueType=='B'?'工程类':(catalogueType=='C'?'服务类':''))}}
      <el-button style="margin-left: 4px" @click="addTableNode()" size="mini" type="default" v-if="globalEdit">
        <i class="el-icon-plus"></i>添加品目
      </el-button>
      <el-button type="text" style="float: right" v-if="openMoreToggle" @click="openMoreToggle = !openMoreToggle" icon="el-icon-arrow-up"></el-button>
      <el-button type="text" style="float: right" v-else  @click="openMoreToggle = !openMoreToggle" icon="el-icon-arrow-down"></el-button>
    </div>
    <el-form :model="dataForm" :rules="validatorRules" label-width="220px" ref="editForm">
      <el-table
              :data="dataForm.tableData"
              v-if="openMoreToggle"
              :row-key="getRowKeys"
              border
              ref="multipleTable"
              stripe
              v-loading="dataListLoading"
      >
        <el-table-column
                fixed
                label="序号"
                type="index"
                :index="indexMethod"
                width="50"
                align="center"
                :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                label="品目"
                prop="purchaseItemName">
          <template slot-scope="scope">
            <template v-if="globalEdit">
              <el-form-item label-width="0px" class="tableInnerForm"
                            :prop="'tableData.'+scope.$index+'.purchaseItemName'"
                            :rules="validatorRules.purchaseItemName">
                <el-input v-model="scope.row.purchaseItemName"></el-input>
              </el-form-item>

            </template>
            <template v-else>
              <span>{{scope.row.purchaseItemName}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                label="品目编码"
                prop="purchaseItemCode"
                width="260px">
          <template slot-scope="scope">
            <template v-if="globalEdit">
              <el-form-item label-width="0px" class="tableInnerForm" :prop="'tableData.'+scope.$index+'.purchaseItemCode'" :error="''" :rules="validatorRules.purchaseItemCode">
                <el-input placeholder="1位大写字母【A/B/C】+8位数字" @change="(val)=>purchaseItemCodeChange(val,scope.$index)" v-model="scope.row.purchaseItemCode"></el-input>
              </el-form-item>
            </template>
            <template v-else>
              <span>{{scope.row.purchaseItemCode}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                label="备注"
                prop="remark">
          <template slot-scope="scope">
            <template v-if="globalEdit">
              <el-form-item label-width="0px" class="tableInnerForm">
                <el-input v-model="scope.row.remark"></el-input>
              </el-form-item>
            </template>
            <template v-else>
              <span>{{scope.row.remark}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                label="是否显示"
                prop="isShow"
                width="100px">
          <template slot-scope="scope">
            <template >
              <el-checkbox :disabled="!globalEdit" v-model="scope.row.isShow" :true-label="1" :false-label="0"></el-checkbox>
            </template>
          </template>
        </el-table-column>
        <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                label="操作"
                v-if="globalEdit"
                width="150px"
        >
          <template slot-scope="scope">
            <el-button
                    @click="editFn(scope.row,1)"
                    class="svg-icon-btn"
                    type="text"
                    :title="'编辑'"
            >
              <icon-svg class="svg-icon" name="edit"></icon-svg>
            </el-button>
            <el-button
                    @click="sortFn(scope.row.versionId,scope.row.id,3,scope.$index)"
                    class="svg-icon-btn"
                    type="text"
                    :title="'置顶'"
            >
              <icon-svg class="svg-icon" name="ding"></icon-svg>
            </el-button>
            <el-button
                    :disabled="!globalEdit"
                    @click="sortFn(scope.row.versionId,scope.row.id,1,scope.$index)"
                    class="svg-icon-btn"
                    style="margin-left: 4px"
                    type="text"
                    :title="'上移'"
            >
              <icon-svg class="svg-icon" name="shang" ></icon-svg>
            </el-button>
            <el-button
                    :disabled="!globalEdit"
                    @click="sortFn(scope.row.versionId,scope.row.id,2,scope.$index)"
                    class="svg-icon-btn"
                    style="margin-left: 4px"
                    type="text"
                    :title="'下移'"
            >
              <icon-svg class="svg-icon" name="xia" ></icon-svg>
            </el-button>
            <el-button
                    :disabled="!globalEdit"
                    @click="deleteTableNode(scope.row,scope.$index)"
                    class="svg-icon-btn"
                    style="margin-left: 4px"
                    type="text"
                    :title="'删除'"
            >
              <icon-svg class="svg-icon" name="delete" ></icon-svg>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
                v-else
                :show-overflow-tooltip="true"
                align="center"
                label="操作"
                width="80px"
        >
          <template slot-scope="scope">
            <el-button
                    @click="editFn(scope.row,2)"
                    class="svg-icon-btn"
                    type="text"
            >
              <icon-svg class="svg-icon" name="openeye"></icon-svg>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import {removeTabHandle} from "@/utils/routeTab";
import {httpMixinsCommonPost} from "@/server/purchase";
const RegItemCode = /^[ABC]\d{8}$/;
const validatorItemCode = (rule, value, callback) =>{
  let reg = RegItemCode;
  if (value == "") {
    callback(new Error("请填写品目编码"));
  } else if (reg.test(value)) {
    callback();
  } else {
    callback(new Error("格式错误，应为：1位大写字母A/B/C+8位数字"));
  }
}
export default {
  props:{
    globalEdit: {
      type: Boolean,
      default: false,
    },
    catalogueType:{
      type: String,
      default: 'A',
    },
    treeNodeId:{
      type: String,
      default: '',
    }
  },
  components: {},
  data() {
    return {
      openMoreToggle:true,
      dataForm:{
        tableData: [],
      },
      tableData:[],
      validatorRules: {
        purchaseItemName: [
          { required: true, message: '请填写品目名称', trigger: 'blur' }
        ],
        purchaseItemCode: [
          { required: true, validator:validatorItemCode, trigger: 'blur' },
        ],
      },
      tableKey:Math.random(),
      dataListLoading:false
    };
  },
  computed: {

  },
  created() {
 
  },
  methods: {
    purchaseItemCodeChange(val,idx){
      let reg = RegItemCode
      if (reg.test(val)) {
        this.$nextTick(()=>{
          var filterResult = this.dataForm.tableData.filter((item, index) => {
            return item.purchaseItemCode == val
          })
          if(filterResult.length == 2) {
            for(let field of this.$refs['editForm'].fields){
              if(field.prop == 'tableData.'+idx+'.purchaseItemCode'){
                field.validateMessage  = '品目编码重复';
                field.validateState = 'error';
                return
              }
            }
          }
        })
      }
      // 接口校验品目编码
      // httpMixinsCommonPost("/purchase/item/checkData", {
      //   versionId:this.treeNodeId,
      //   purchaseItemCode:val,
      //   catalogType:this.catalogueType,
      // }).then(res => {
      //   if (res.data.code != "1") {
      //     for(let field of this.$refs['editForm'].fields){
      //       if(field.prop == 'tableData.'+idx+'.purchaseItemCode'){
      //         field.validateMessage  = res.data.msg;
      //         field.validateState = 'error';
      //         return
      //       }
      //     }
      //     this.$message({
      //       type: "error",
      //       message: res.data.msg
      //     });
      //   }
      // });

    },
      validateAndGetCatalogueItemForm(callback){
        // 触发表单验证
        return new Promise((resolve,rejects)=>{
          this.$refs.editForm.validate((valid) => {
            if (valid) {
              resolve(this.getSortedTableData())
            }else{
              this.scrollToErrorItem(this.$refs['editForm']);
              rejects(false)
            }
          });
        })
      },
      scrollToErrorItem(elDom) {
        var errorElDom = elDom.fields.filter((item) => {
          return item.validateState === 'error';
        });
        if(errorElDom.length){
          errorElDom[0].$el.scrollIntoView({ block: 'center', behavior: 'smooth' })
        }
      },
      getSortedTableData(){
          this.dataForm.tableData.forEach((item,index)=>{
              item.sort = index + 1;
          })
          return this.dataForm.tableData
      },
    indexMethod(index) {
      return index + 1;
    },
    deleteTableNode(row, index) {
      this.$confirm("确认要删除该数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(() => {
          this.dataForm.tableData.splice(index, 1);
        }).catch(() => {
        });
    },
    editFn(row,type){
      if(row.id){
        removeTabHandle('purchaseCatalogueDetail')
        this.$router.push({
          name:'purchaseCatalogueDetail',
          query:{
            id:row.id,
            type:type
          }
        })
      }else{
        this.$message.error('请先保存表格数据。')
      }

    },
    sortFn(pid, id, type, index) {
      // 1 上 2下 3置顶
      if ((type == 1 || type == 3) && index == 0) {
        this.$message.error("已到顶部，不可上移。");
        return;
      }
      if (type == 2 && index == this.dataForm.tableData.length - 1) {
        this.$message.error("已到底部，不可下移。");
        return;
      }
      var splice = this.dataForm.tableData.splice(index, 1);
      if (type == 3) {
        this.dataForm.tableData.unshift(splice[0]);
      }
      if (type == 1) {
        this.dataForm.tableData.splice(index - 1, 0, splice[0]);
      }
      if (type == 2) {
        this.dataForm.tableData.splice(index + 1, 0, splice[0]);
      }
      // this.$http({
      //     url: `/***/moveSort?id=${id}&type=${type}`,
      //     method: 'get',
      // }).then(({data}) => {
      //     if(data.code==1){
      //         this.getTableList(pid)
      //         // let filters = this.treeData[0].children.filter((item)=>item.id == pid);
      //         // if(filters.length > 0)this.getTableList(filters[0]);
      //     }else{
      //         this.$message.error(data.msg)
      //     }
      // })
    },

    resetEdit() {
      this.globalEdit = false;
    },
    getRowKeys(row) {
      return row.staticId;
    },
    addTableNode(type) {
      //添加表格数据
      if (this.treeNodeId && this.treeNodeId != "1") {
        let tableItem = {
          versionId:this.treeNodeId,
          staticId:Math.random(),
          purchaseItemName: "",
          purchaseItemCode:'',
          catalogType:this.catalogueType,
          remark:'',
          isShow:1,
          editRow: true,
        };
        this.dataForm.tableData.push(tableItem);
      } else {
        this.$message.error("请先选择采购年度数据。");
      }
    },

    deleteNode(node, data) {
      // const parent = node.parent;
      // const children = parent.data.children || parent.data;
      // const index = children.findIndex(d => d.id === data.id);
      // var item = children[index];
      // this.$refs.tree.remove(item)
      this.$confirm(`确定要删除该数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // this.$http.post("/**/delete", {
        //     id: data.id
        //   })
        //   .then(res => {
        //     if (res.data.code == "1") {
        //       this.$message({
        //         type: "success",
        //         message: res.data.msg
        //       });
        //       this.getTreeData();
        //     } else {
        //       this.$message({
        //         type: "error",
        //         message: res.data.msg
        //       });
        //     }
        //   });
      });
    },


    dragSort() {
      const el = this.$refs.multipleTable.$el.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];

      this.sortable = Sortable.create(el, {
        ghostClass: "sortable-ghost",

        setData: function(dataTransfer) {
          dataTransfer.setData("Text", "");
        },

        onEnd: e => {
          //e.oldIndex为拖动一行原来的位置，e.newIndex为拖动后新的位置

          const targetRow = this.dataForm.tableData.splice(e.oldIndex, 1)[0];

          this.dataForm.tableData.splice(e.newIndex, 0, targetRow);

          console.log(this.dataForm.tableData, "排序后的数据");

          let dragId = this.dataForm.tableData[e.newIndex].id; //拖动行的id

          let oneId, twoId;

          //拖动行的前一行

          if (this.dataForm.tableData[e.newIndex - 1]) {
            oneId = this.dataForm.tableData[e.newIndex - 1].id;
          } else {
            oneId = "";
          }

          //拖动行的后一行
          if (this.dataForm.tableData[e.newIndex + 1]) {
            twoId = this.dataForm.tableData[e.newIndex + 1].id;
          } else {
            twoId = "";
          }

          console.log(dragId, oneId, twoId);
        }
      });
    },


    // 获取交易数据预警表格数据
    getTableList(id) {
      // this.dataListLoading = true;
      // httpMixinsCommonGet("/***?id=" + id)
      //   .then(res => {
      //     let resData = res.data.data || [];
      //     this.dataForm.tableData = resData;
      //     this.dataListLoading = false;
      //   });
      // this.dataListLoading = false;
      // this.dataForm.tableData = []
    },
    setTableList(Arr) {
      this.dataForm.tableData = Arr.map(item => {
        return {
          ...item,
          catalogType:this.catalogueType,
          staticId: item.id,
        }
      });

    }
  },
  mounted() {
    // this.dragSort();
  }
};
</script>
<style lang="less" scoped>
  .defaultTableHeader{
    background-color: #E3ECFB;padding: 16px
  }
  .tableInnerForm{
    margin-bottom: 16px;
  }
</style>
